import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { LOCATIONS_PATH } from '../utils/siteDrillThrough';

/**
 * A site used to have its own page. It now opens over the Locations list, the way QP Tracking
 * opens a task, so an old /locations/:siteId link lands on the list with that site open.
 */
const SiteDetailPage: React.FC = () => {
  const { siteId = '' } = useParams<{ siteId: string }>();
  return <Navigate to={`${LOCATIONS_PATH}?site=${encodeURIComponent(siteId)}`} replace />;
};

export default SiteDetailPage;
